<template>
  <v-sheet class="booking-language-select d-flex px-4 my-4" :lang="domLanguage" style="gap: 4px">
    <v-btn x-small depressed dense :aria-label="item.label" :color="lang === item.symbol ? '#d9bddd' : 'white grey--text'" class="text-caption pa-0" v-for="item in supportLang" :key="item.title" @click="setLang(item.symbol)">
      {{ item.title }}</v-btn
    >
  </v-sheet>
</template>
<script>
import { mapState, mapGetters, mapMutations } from "vuex"
export default {
  data: () => ({
    supportLang: [
      {
        title: "KOR",
        symbol: "ko",
        label: "한국어",
      },
      {
        title: "ENG",
        symbol: "en",
        label: "English",
      },
      {
        title: "JPN",
        symbol: "jp",
        label: "日本語",
      },
    ],
  }),
  computed: {
    ...mapState(["lang"]),
    domLanguage() {
      return this.lang === "jp" ? "ja" : this.lang
    },
  },

  methods: {
    ...mapMutations(["SET_LANG"]),
    setLang(item) {
      this.SET_LANG(item)
    },
  },
}
</script>
<style scoped>
::v-deep .v-btn {
  border: 1px solid #ccc !important;
  font-size: 10px !important;
  padding-left: 2px !important;
  padding-right: 2px !important;
}
</style>
<style>
.booking-language-select {
  --language-font-body: "Noto Sans JP";
  --language-font-display: "Noto Sans JP";
}

.booking-language-select[lang="ja"] {
  font-family: var(--language-font-body);
}

.booking-language-select[lang="ja"] .v-btn {
  font-family: var(--language-font-display) !important;
}

body.booking-ui-v2-active .booking-language-select {
  gap: 0 !important;
  padding-right: 8px !important;
  padding-left: 8px !important;
}

body.booking-ui-v2-active .booking-language-select .v-btn {
  min-width: 44px !important;
  min-height: 44px !important;
}
</style>
